import {createApp} from 'vue';
import App from './App.vue';
import {isProduction} from '@/utils';

function mountApp(id) {
  createApp(App).mount(id);
}

function doCreateRoot() {
  if (document && document.body && document.body.appendChild) {
    const div = document.createElement('div');
    div.setAttribute('id', 'online-serve-chat');
    document.body.appendChild(div);
    setTimeout(() => mountApp('#online-serve-chat'));
  } else {
    setTimeout(doCreateRoot);
  }
}

setTimeout(() => {
  if (isProduction()) {
    doCreateRoot();
  } else {
    mountApp('#app');
  }
});
